// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-product-img-upload {\n  width: 112px;\n  height: 112px;\n  border: solid 1px #eee;\n  padding: 3px;\n  border-radius: 3px;\n}", ""]);
// Exports
module.exports = exports;
